(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dragon-entry"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = root => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      const opening = root.querySelector('[data-opening]');
      const player = root.querySelector('[data-player]');
      const video = root.querySelector('[data-video]');
      const enter = root.querySelector('[data-enter]');
      const finalFade = root.querySelector('[data-final-fade]');
      const failure = root.querySelector('[data-failure]');
      const destination = root.dataset.destination || '/products/gold-dragon-charm';
      const fade = Math.max(0, Number(root.dataset.fade) || 300);
      const configuredTimeout = Math.max(0, Number(root.dataset.fallback) || 0);
      const preview = root.dataset.preview === 'true' && window.Shopify && Shopify.designMode;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const sessionKey = 'dragon-entry-seen';
      const dayKey = 'dragon-entry-day';
      let fallbackTimer;
      let navigating = false;

      const shouldShow = () => {
        if (preview) return true;
        if (root.dataset.frequency === 'every') return true;
        if (root.dataset.frequency === 'daily') return localStorage.getItem(dayKey) !== new Date().toISOString().slice(0, 10);
        return sessionStorage.getItem(sessionKey) !== 'true';
      };
      const markSeen = () => {
        try {
          sessionStorage.setItem(sessionKey, 'true');
          localStorage.setItem(dayKey, new Date().toISOString().slice(0, 10));
        } catch (error) {}
      };
      const unlock = () => document.documentElement.classList.remove('dragon-entry-lock');
      const redirect = () => {
        if (navigating) return;
        navigating = true;
        clearTimeout(fallbackTimer);
        markSeen();
        finalFade.classList.add('is-active');
        window.setTimeout(() => {
          unlock();
          window.location.assign(destination);
        }, fade);
      };
      const skip = () => redirect();
      const fail = () => {
        clearTimeout(fallbackTimer);
        failure.hidden = false;
        const errorRegion = failure.querySelector('[data-error]');
        if (errorRegion) errorRegion.textContent = 'The introduction could not play. Continue to shop.';
      };
      const scheduleFallback = () => {
        const durationMs = Number.isFinite(video.duration) ? video.duration * 1000 : 0;
        const timeout = configuredTimeout > 0 ? configuredTimeout : durationMs + 2000;
        fallbackTimer = window.setTimeout(redirect, Math.max(timeout, 2000));
      };
      const begin = async () => {
        enter.disabled = true;
        markSeen();
        opening.classList.add('is-leaving');
        document.documentElement.classList.add('dragon-entry-lock');
        if (reduced) {
          finalFade.classList.add('is-active');
          window.setTimeout(redirect, Math.min(fade, 300));
          return;
        }
        window.setTimeout(async () => {
          player.classList.add('is-active');
          player.setAttribute('aria-hidden', 'false');
          video.currentTime = 0;
          video.muted = root.dataset.sound !== 'true';
          try {
            await video.play();
          } catch (firstError) {
            if (!video.muted) {
              video.muted = true;
              try { await video.play(); } catch (secondError) { fail(); return; }
            } else { fail(); return; }
          }
          scheduleFallback();
        }, fade);
      };

      if (!shouldShow()) {
        root.hidden = true;
        root.classList.add('is-complete');
        return;
      }
      document.documentElement.classList.add('dragon-entry-lock');
      if (window.innerWidth < 750) {
        const mobilePoster = root.querySelector('[data-mobile-poster]');
        if (mobilePoster) video.poster = mobilePoster.dataset.mobilePoster;
      }
      enter.addEventListener('click', begin);
      root.querySelectorAll('[data-skip]').forEach(button => button.addEventListener('click', skip));
      video.addEventListener('ended', redirect);
      video.addEventListener('error', fail);
      document.addEventListener('keydown', event => { if (event.key === 'Escape' && !root.hidden) skip(); });
      enter.focus({ preventScroll: true });
    };
    document.querySelectorAll('[data-dragon-entry]').forEach(init);
    document.addEventListener('shopify:section:load', event => init(event.target.querySelector('[data-dragon-entry]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
